import { useState } from "react";
import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { topicWall } from "@/mocks/homeData";

export default function TopicWall() {
  const [active, setActive] = useState<string>("宿舍矛盾");

  return (
    <section id="topics" className="w-full border-y border-foreground-900/10 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-8 md:py-24">
        <Reveal>
          <SectionHeading
            index="01"
            eyebrow="Topic Wall"
            title="话题墙：大家正在讨论什么"
            desc="按话题浏览校内讨论，从宿舍矛盾到考试争议，每个标签下都对应着学校回应、同学爆料与后续处理结果。点击标签即可查看对应话题的收敛方向。"
          />
        </Reveal>

        <Reveal className="mt-10 md:mt-14" delay={80}>
          <div className="flex flex-wrap items-center gap-2.5 md:gap-3">
            {topicWall.map((topic) => {
              const isActive = active === topic.name;
              return (
                <button
                  key={topic.name}
                  type="button"
                  onClick={() => setActive(topic.name)}
                  className={[
                    "group flex cursor-pointer items-center gap-2 rounded-full border px-4 py-2 text-sm transition-colors md:px-5 md:py-2.5",
                    isActive
                      ? "border-primary-500 bg-primary-500 text-background-50"
                      : "border-background-300/70 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-foreground-950",
                    topic.hot && !isActive ? "text-foreground-900" : "",
                  ].join(" ")}
                >
                  <span className="whitespace-nowrap">{topic.name}</span>
                  <span
                    className={[
                      "font-heading text-xs",
                      isActive ? "text-background-50/80" : "text-foreground-400",
                    ].join(" ")}
                  >
                    {topic.count}
                  </span>
                  {topic.hot ? (
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i
                        className={
                          isActive
                            ? "ri-fire-line text-[13px] text-background-50"
                            : "ri-fire-line text-[13px] text-accent-500"
                        }
                      />
                    </span>
                  ) : null}
                </button>
              );
            })}
          </div>
        </Reveal>

        <Reveal className="mt-8 md:mt-10" delay={140}>
          <div className="flex flex-col gap-1 rounded-lg border border-background-300/60 bg-background-50 px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-sm text-foreground-600">
              当前选中话题：
              <span className="font-heading font-semibold text-foreground-950">{active}</span>
            </p>
            <p className="text-xs text-foreground-500">
              话题按讨论热度排序，热度只代表关注度，不代表事件已核实。
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}